import * as Portals from "@ionic/portals";
import { useEffect, useState } from "react";
import type { PluginListenerHandle } from "@capacitor/core";

export interface PublishWithSubtopic<T> {
	subtopic: string;
	data: T;
}

export interface TkitInitialContext {
	token: string; // "" if no token
	route: string;
}

export const usePortalsInitialContext = () => {
	const [data, setData] = useState<TkitInitialContext | undefined>();

	useEffect(() => {
		const ctx = Portals.getInitialContext<TkitInitialContext>();
		if (ctx && ctx.name === "tkit" && ctx.value !== undefined) {
			setData(ctx.value);
		}
	}, []);

	return { data };
};

export const usePortalsSubscribe = <T>(topic: string, callback: (data: T) => void) => {
	useEffect(() => {
		let handle: PluginListenerHandle;
		Portals.subscribe<T>(topic, (msg) => {
			callback(msg.data as T);
		}).then((h) => {
			handle = h;
		});
		return () => {
			handle?.remove();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [topic]);
};

export const openOadt = (route: string) => {
	return Portals.publish({
		topic: "openOadt",
		data: route,
	});
};
